"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservabilityPipelineSampleProcessor = void 0;
/**
 * The `sample` processor allows probabilistic sampling of logs at a fixed rate.
 */
class ObservabilityPipelineSampleProcessor {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return ObservabilityPipelineSampleProcessor.attributeTypeMap;
    }
}
exports.ObservabilityPipelineSampleProcessor = ObservabilityPipelineSampleProcessor;
/**
 * @ignore
 */
ObservabilityPipelineSampleProcessor.attributeTypeMap = {
    id: {
        baseName: "id",
        type: "string",
        required: true,
    },
    include: {
        baseName: "include",
        type: "string",
        required: true,
    },
    inputs: {
        baseName: "inputs",
        type: "Array<string>",
        required: true,
    },
    percentage: {
        baseName: "percentage",
        type: "number",
        format: "double",
    },
    rate: {
        baseName: "rate",
        type: "number",
        format: "int64",
    },
    type: {
        baseName: "type",
        type: "ObservabilityPipelineSampleProcessorType",
        required: true,
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=ObservabilityPipelineSampleProcessor.js.map